import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerDownRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowCornerDownRight"><Path d="M3.5 4.5V15H20" stroke="currentColor" strokeLinecap="square"/><Path d="M16 10.5L20.5 15L16 19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowCornerDownRight;
